<template>
  <div>
    <div>
      <documents-list
        :resource-id="driverData.id"
        resource-type="driver"
      />

    </div>
  </div>
</template>

<script>
import DocumentsList from '@/views/driver/documents/DocumentsList.vue'

export default {
  components: {
    DocumentsList,
  },
  props: {
    driverData: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
